import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface SerialSequenceNotFoundModalProps {
  title: string
  serialSequenceId: string
  onClose: () => void
}

export const SerialSequenceNotFoundModal = ({
  title,
  serialSequenceId,
  onClose,
}: SerialSequenceNotFoundModalProps) => {
  return (
    <Modal
      illustration="input-field"
      title={title}
      description={i18n.t('finance.serial_sequences.modal.sequence_not_found')}
      onClose={onClose}
      footer={
        <Button type="secondary" onClick={onClose}>
          {i18n.t('common.close')}
        </Button>
      }
    >
      <Box gap="s16">
        <Text.Normal>
          {i18n.t('finance.serial_sequences.modal.sequence_not_found_message', {
            id: serialSequenceId,
          })}
        </Text.Normal>
      </Box>
    </Modal>
  )
}
